"use strict";
ui.loadTemplateFile("news.html");

class NewsDialog extends Dialog {
    _element: any;
    _newsContent: any;

    constructor() {
        super("news.html");

        this._newsContent = ui.label(this, ".label.news-content");

        // Position on the left side with 80% height and 20% width
        this._element.css({
            position: "absolute",
            left: "10px",
            top: "10%",
            width: "20%",
            height: "80%",
            zIndex: "1000",
        });

        // Remove close button if it exists
        this._element.find(".close-button").remove();

        // Fetch news from the info server
        this._fetchNews();

        // Make it always visible (don't call show() as it might make it modal)
        this._element.show();
    }

    _fetchNews() {
        fetch((config.infoUrl || "http://localhost:28900") + "/news")
            .then((response) => response.json())
            .then((data) => {
                this._newsContent.text(data.message);
            })
            .catch((error) => {
                console.error("Failed to fetch news:", error);
                this._newsContent.text("Unable to load news at this time.");
            });
    }
}

ui.NewsDialog = NewsDialog;
ui.newsDialog = () => {
    return new ui.NewsDialog();
};
